// extracted by mini-css-extract-plugin
module.exports = {"Alcalde":"Alcalde_Alcalde__2lDpI","Justify":"Alcalde_Justify__19Umc","DatosAlcalde":"Alcalde_DatosAlcalde__8AUWb","Parrafo":"Alcalde_Parrafo__1HYsm"};